import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { user, isAuthenticated } = useAuth();

  

  if (!isAuthenticated && !user) {
    //console.log('‼️ REDIRECTING: User not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }
  
  // Jeśli wymagane są role
  if (requiredRoles.length > 0) {
    const isAdmin = user?.role === 'admin';
    const hasRequiredRole = isAdmin || requiredRoles.includes(user?.role);
    
    //console.log('Is admin?', isAdmin);
    //console.log('Has required role?', hasRequiredRole);
    
    if (!hasRequiredRole) {
      //console.log('‼️ ACCESS DENIED: User lacks required role');
      return <Navigate to="/" replace />;
    }
  }
  
  //console.log('✅ ACCESS GRANTED: Rendering protected content');
  return children;
};

export default ProtectedRoute;